import React from "react";
import { TestimonialCard } from "./TestimonialCard";
import { testimonials } from "../data/testimonials";
export function SocialProofSection() {
  return <section aria-labelledby="social-proof-heading" className="relative isolate w-full overflow-hidden bg-[#090B0D] py-20 text-[#F8F8F6] sm:py-24 lg:py-28" data-id="element-198" data-mp="2qz7z1ow0z7tz">
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-1/2 -z-10 h-[82%] w-[90%] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[radial-gradient(circle,rgba(242,184,75,0.055),transparent_70%)]" data-id="element-199" data-mp="30s59d7qv5qhi" />

      <div className="mx-auto max-w-[1040px] px-4 sm:px-8 lg:px-12" data-id="element-200" data-mp="283zrcsr72fld">
        <header className="text-center" data-id="element-201" data-mp="2n0qpyzt1nn9x">
          <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-[#F2B84B] sm:text-xs" data-id="element-202" data-mp="2mxmctcxlph74">
            EXPERIENCIAS REALES
          </p>
          <h2 id="social-proof-heading" className="mx-auto mt-4 max-w-[760px] text-[2rem] font-bold leading-tight tracking-[-0.035em] text-[#F8F8F6] sm:text-[2.5rem] lg:text-[3.25rem]" data-id="element-203" data-mp="28owaihvq78e">
            Profesionales que ya lo están usando
          </h2>
        </header>

        <div className="mx-auto mt-10 flex max-w-[900px] flex-col gap-7 sm:mt-12 sm:gap-8 lg:mt-14" data-id="element-204" data-mp="13edals48elc3">
          {testimonials.map(testimonial => <TestimonialCard key={testimonial.name} testimonial={testimonial} data-id="element-205" data-mp="18ehuls4cly72" />)}
        </div>
      </div>
    </section>;
}